import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import { SPACING_UNIT } from '../../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';
import DummyContent from '../../primitive/DummyContent';

interface Props {
  className?: string;
}

const DummyField = ({ className }: Props & ClassAttributes<HTMLElement>) => {
  return (
    <Root className={className}>
      <Label />

      <Value length={66} />
    </Root>
  );
};

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['20%', `${SPACING_UNIT * 3}px`, '1fr'],
    rows: ['1fr'],
    areas: [['label', '.', 'input']],
  }),
);

const Label = styled(DummyContent)(gridLayoutItem('label', { justifySelf: 'flex-end' }));

const Value = styled(DummyContent)(gridLayoutItem('input'));

export default DummyField;
